import Marquee from "react-fast-marquee";
import {
  SiHtml5,
  SiCss,
  SiJavascript,
  SiPhp,
  SiCodeigniter,
  SiAngular,
  SiMysql,
  SiMariadb,
  SiGithub,
  SiFigma,
  SiCpanel,
} from "react-icons/si";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

const TECHS = [
  { name: "HTML", Icon: SiHtml5, color: "#E34F26" },
  { name: "CSS", Icon: SiCss, color: "#1572B6" },
  { name: "JavaScript", Icon: SiJavascript, color: "#F7DF1E" },
  { name: "PHP", Icon: SiPhp, color: "#777BB4" },
  { name: "CodeIgniter", Icon: SiCodeigniter, color: "#EF4223" },
  { name: "Angular", Icon: SiAngular, color: "#DD0031" },
  { name: "MySQL", Icon: SiMysql, color: "#4479A1" },
  { name: "MariaDB", Icon: SiMariadb, color: "#003545" },
  { name: "GitHub", Icon: SiGithub, color: "#ffffff" },
  { name: "Figma", Icon: SiFigma, color: "#F24E1E" },
  { name: "cPanel", Icon: SiCpanel, color: "#FF6C2C" },
];

const TechStack = () => {
  const { t } = useLang();

  return (
    <section
      id="tech"
      className="relative px-6 md:px-10 py-24 md:py-32 border-t border-white/10 overflow-hidden"
      data-testid="tech-section"
    >
      <div className="max-w-[1500px] mx-auto">
        <div className="text-xs uppercase tracking-[0.3em] text-[#ff4500] mb-6">
          {t.sectionLabels.tech}
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-display text-[10vw] md:text-6xl lg:text-7xl whitespace-pre-line max-w-4xl"
          data-testid="tech-title"
        >
          {t.tech.title}
        </motion.h2>
        <p className="mt-6 text-white/60 max-w-2xl text-base md:text-lg leading-relaxed">
          {t.tech.sub}
        </p>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {TECHS.map(({ name, Icon, color }, i) => (
            <motion.div
              key={name}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              className="group flex flex-col items-center justify-center gap-3 aspect-square rounded-3xl border border-white/10 bg-[#0f0f0f] hover:bg-white hover:border-white transition cursor-default"
              data-testid={`tech-item-${name.toLowerCase()}`}
            >
              <Icon size={36} style={{ color }} className="transition group-hover:scale-110" />
              <span className="text-sm font-medium text-white/70 group-hover:text-black transition">
                {name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Bottom marquee */}
      <div className="mt-20 -mx-6 md:-mx-10 border-y border-white/10 py-6 bg-[#0a0a0a]">
        <Marquee gradient={false} speed={50} pauseOnHover>
          {[...TECHS, ...TECHS].map((tech, i) => (
            <span key={`${tech.name}-${i}`} className="tech-pill">
              <tech.Icon size={18} style={{ color: tech.color }} />
              {tech.name}
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default TechStack;
